import { useContext } from 'react';
import { ReviewCheckToggleContext, ReviewCheckToggleContextType } from '#baseMenu/components';

const useReviewCheckToggleContext = () => useContext<ReviewCheckToggleContextType>(ReviewCheckToggleContext);

export { useReviewCheckToggleContext };
